import { Link, LinkProps } from '@chakra-ui/next-js'
import { clsx } from 'clsx'
import styles from 'components/links/NewAnimatedLink/styles.module.scss'
import { FC } from 'react'

export interface NewAnimatedLinkProps extends LinkProps {
  isActive?: boolean
}

const NewAnimatedLink: FC<NewAnimatedLinkProps> = ({ children, href, isActive, ...rest }) => {
  if (href) {
    return (
      <Link prefetch={false} textDecoration="none !important" className={styles.menuItem} {...{ href }} {...rest}>
        <span className={clsx(styles.link, { [styles.activeItem]: isActive })}>{children}</span>
      </Link>
    )
  }

  return <span className={clsx(styles.link, { [styles.activeItem]: isActive })}>{children}</span>
}

export default NewAnimatedLink
